import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { useSwitchUtenze } from '../hooks/useSwitchUtenze';

/**
 * Switch Utenze card (web port of the mobile `renderSwitchUtenzeSection`).
 * Lets an employee registered in more than one company jump to another of their
 * accounts without re-entering credentials. Renders nothing when there are no
 * alternative accounts (or the fetch failed).
 */
export default function SwitchUtenzeSection() {
  const { utenze, totalMatches, switchCompany, switching, switchError } = useSwitchUtenze();

  if (!utenze || utenze.length === 0) return null;

  const aziendeLabel =
    totalMatches === 1
      ? "a 1 altra azienda"
      : `ad altre ${totalMatches} aziende`;

  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-base font-semibold leading-7 text-indigo-800">Cambia Azienda</h3>
        <p className="mt-1 text-sm text-gray-500">
          Hai accesso {aziendeLabel}. Seleziona l’azienda con cui vuoi operare.
        </p>

        {switchError && (
          <p className="mt-3 rounded-md bg-red-50 px-3 py-2 text-sm text-red-700" role="alert">
            Si è verificato un errore durante il cambio azienda. Riprova.
          </p>
        )}

        <ul className="mt-4 space-y-3">
          {utenze.map((employee) => {
            const company = employee?.company;
            const employeeLabel =
              employee?.first_name || employee?.last_name
                ? `${employee?.first_name || ""} ${employee?.last_name || ""}`.trim()
                : employee?.cf || "-";

            if (!company?.id) return null;

            return (
              <li key={company.id}>
                <button
                  type="button"
                  disabled={switching}
                  onClick={() => switchCompany(company.id)}
                  className="flex w-full items-center justify-between rounded-lg border-l-4 border-indigo-500 bg-gray-50 px-4 py-3 text-left transition hover:bg-indigo-50 disabled:cursor-not-allowed disabled:opacity-60"
                >
                  <span className="flex flex-col">
                    <span className="text-sm font-semibold text-gray-900">
                      {company?.business_name || "Azienda"}
                    </span>
                    <span className="text-xs">
                      Codice Azienda: {company.id}
                    </span>
                    <span className="text-sm text-gray-500">
                      {employeeLabel}
                    </span>
                  </span>

                  <ChevronRightIcon
                    className="h-5 w-5 flex-shrink-0 text-indigo-600"
                    aria-hidden="true"
                  />
                </button>
              </li>
            );
          })}
        </ul>

        {switching && <p className="mt-3 text-sm text-gray-500">Cambio azienda in corso…</p>}
      </div>
    </div>
  );
}
